import styled from 'styled-components';
import { tablet768 } from '@nubank/nuds-web/styles/breakpoints';

import Section from 'components/structure/Section';

const SectionRoot = styled(Section)`
  ${tablet768`
    & > * {
      flex-direction: column;
    }
  `}
`;

SectionRoot.displayName = 'SectionRoot';

export default SectionRoot;
